// Development / sandbox configuration.
//
// Production values live in `environment.prod.ts` and are swapped in automatically
// by the angular.json `fileReplacements` for `ng build --configuration production`.
// Do NOT re-add production URLs/keys here as comments — that is what the VAPT flagged.
//
// SECURITY: everything in this file ships to the browser. Never place a real secret
// here. `PUBLIC_KEY` is a publishable (client-side) key, not a secret.

export const environment = {
  production: false,
  BASE_DOMAIN: 'http://localhost:4200/#/',
//  BASE_DOMAIN: 'https://business.xcelapp.com/#/',
  API_URL : "https://sandbox-api.xcelapp.com/asa/gateway/business-api",
  API_URL2 : "https://sandbox-api.xcelapp.com",
  CUSTOMER_MANAGEMENT_URL : "https://sandbox-api.xcelapp.com/asa/gateway/customer-managment",
  TRANSACTION_URL:"https://sandbox-api.xcelapp.com/asa/gateway/transactions-service",
  ADMIN_BASE_URL : "https://sandbox-api.xcelapp.com/asa/gateway/administrator",
  ESA_URL : "https://sandbox-api.xcelapp.com/asa/gateway/esa",
  MERCHANT_AUTH_URL: "https://sandbox-api.xcelapp.com/asa/gateway/merchant-auth",
  API_URL3 : "https://sandbox-api.xcelapp.com/asa/gateway/xas/v1",
  X_APP_ID: '64c053730656499e578826c0',
  X_ISSUER_ID: '64c051b60656499e578826bf',
  PUBLIC_KEY: 'eTz.live_faf2ab8387b08df3d51d85c5e43f11e9d46f4a49cd9943b0f2fcd174bb7830d1',
  PAYMENT_LINK: 'https://paygate.xcelapp.com/pay/',

};
